<template>
  <div class="min-h-screen w-full bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from 'vue'
import { useTheme } from '../../utils/useTheme'

export default defineComponent({
  name: 'MainTheme',
  setup() {
    const theme = useTheme()

    // Make theme available to all components via provide/inject
    provide('theme', theme)

    return {
      theme
    }
  }
})
</script>

<style>
/* Common transition styles */
.card,
.header,
.input,
.btn-secondary,
body {
  transition:
    background-color 0.3s,
    border-color 0.3s,
    color 0.3s;
}
</style>
